import React, { useEffect, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { getRateListPackage } from "../actions/GenomicsAdminAction";
import { connect } from "react-redux";
import { useRef } from "react";
import Loader from "../Components/loader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "155px",
      textTransform: "capitalize",
    },
    margin: {
      margin: theme.spacing(1),
    },
    table: {
      maxWidth: "100%",
      margin: "auto",
    },
    center: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    start: {
      display: "flex",
      justifyContent: "flex-start",
    },
    end: {
      display: "flex",
      justifyContent: "flex-end",
    },
    gap: {
      fontSize: "14px",
      margin: "0 -40px 0 40px",
    },
    select: {
      margin: "0 0 0 -8px",
      minWidth: "155px",
      width: "100%",
      height: "40px",
    },
    textFieldGap: {
      padding: "0 10px",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    startIt: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    checkBoxGap: {
      padding: "0 40px",
    },
    formContorlLabel: {
      padding: "0 0 0 25px",
      margin: "0 0 0 15px",
      color: "rgba(0, 0, 0, 0.54)",
    },
  })
);
interface Props {
  RateListId: any;
  testId: any;
  getRateListPackage: any;
  rateListPackage: any;
  loading: boolean;
}
const RateList: React.FC<Props> = ({
  RateListId,
  testId,
  getRateListPackage,
  rateListPackage,
  loading,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [center, setCenter] = useState<any>([]);
  const [centreId, setCentreId] = useState<any>([]);
  const [tableRows, setTableRows] = useState<any>([]);

  useEffect(() => {
    if (RateListId !== "") {
      getRateListPackage(RateListId, `name_or_code=${testId}`);
    } else {
      setTableRows([]);
    }
  }, [RateListId, testId]);
  const [page, setPage] = useState(0);
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        rateListPackage.links && rateListPackage.links.next.split("?")[1];
      getRateListPackage(RateListId, url);
    } else if (newPage < page) {
      let url =
        rateListPackage.links && rateListPackage.links.previous.split("?")[1];
      getRateListPackage(RateListId, url);
    }
    setPage(newPage as number);
  };
  useEffect(() => {
    if (
      RateListId !== "" &&
      rateListPackage.results &&
      rateListPackage.results.length > 0
    ) {
      let temp: any = [];
      rateListPackage.results.map((element: any) => {
        temp.push({
          code: element.code,
          name: element.name,
          package_price: element.prices.base_price,
          offer_price:
            element.prices.special_price_for_center !== 0
              ? element.prices.special_price_for_center
              : "",
          lab_offer_price: element.prices.lab_offer_price,
          discount_percentage: element.prices.rate_percentage,
          discount_category: element.test_category.name,
        });
      });
      setTableRows(temp);
    }
  }, [rateListPackage]);

  return (
    <form className={classes.root} style={{ width: "100%", marginTop: 20 }}>
      <Grid container>
        <Grid item xs={12}>
          <Paper style={{ width: "100%" }}>
            <TableContainer style={{ height: "450px" }}>
              {loading ? (
                <Loader />
              ) : (
                <Table aria-label="simple table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S. No.</TableCell>
                      <TableCell align="center">Test Code</TableCell>
                      <TableCell align="center">Test Name</TableCell>
                      <TableCell align="center">Discount Category</TableCell>
                      <TableCell align="center">Discount percentage</TableCell>
                      <TableCell align="center">Lab Mrp</TableCell>
                      <TableCell align="center">Rcl Share</TableCell>
                      <TableCell align="center">Special Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableRows &&
                      tableRows.length > 0 &&
                      tableRows.map((row: any, index: number) => {
                        return (
                          <TableRow key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{row.code}</TableCell>
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">
                              {row.discount_category}
                            </TableCell>
                            <TableCell align="center">
                              {row.discount_percentage}
                            </TableCell>
                            <TableCell align="center">
                              {row.package_price}
                            </TableCell>
                            <TableCell align="center">
                              {row.lab_offer_price}
                            </TableCell>
                            <TableCell align="center">
                              {row.offer_price}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
            {rateListPackage.count === undefined ? (
              <></>
            ) : (
              <TablePagination
                rowsPerPageOptions={[]}
                colSpan={3}
                count={rateListPackage.count}
                rowsPerPage={rateListPackage.page_size}
                page={page}
                onPageChange={handleChangePage}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state: any) => ({
  rateListPackage: state.GenomicsAdminReducer.rateListPackage,
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  getRateListPackage,
})(RateList);
